import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithReauth, getApiConfig } from "shared/api"
import { mastersApi } from "../masters/slice"

const { BASE_URL, prepareHeaders } = getApiConfig()
const SERVICES_PATH = "master/services"

function transformGetServicesResponse({ data }) {
  return data.map(
    ({
      id,
      name,
      price,
      duration,
      direction_service,
      sub_direction_service,
    }) => ({
      id,
      name,
      price,
      duration,
      category: {
        id: direction_service?.id ?? "",
        name: direction_service?.name ?? "",
      },
      subCategory: {
        id: sub_direction_service?.id ?? "",
        name: sub_direction_service?.name ?? "",
      },
    })
  )
}

export const servicesApi = createApi({
  reducerPath: "servicesApi",
  tagTypes: ["Services"],
  baseQuery: baseQueryWithReauth({baseUrl: BASE_URL, prepareHeaders}),
  endpoints: (builder) => ({
    // get all

    getServices: builder.query({
      query: () => `/${SERVICES_PATH}`,
      providesTags: (someData) =>
        someData?.data
          ? [
              ...someData?.data?.map(({ id }) => ({ type: "Services", id })),
              { type: "Services", id: "LIST" },
            ]
          : [{ type: "Services", id: "LIST" }],
      transformResponse: transformGetServicesResponse
    }),
    getServiceFilter:builder.query({
      query: () => `/${SERVICES_PATH}`,
    }),
    // post
    postService: builder.mutation({
      query: ({service, direction, subCategory}) => ({
        url: `/${SERVICES_PATH}`,
        method: "POST",
        // SET CORRECT SALON_ID !!!
        body: { ...service, sub_direction_service_id: subCategory.id, direction_service_id: direction.id },
      }),
      invalidatesTags: [{ type: "Services", id: "LIST" }],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
          // Инвалидируем теги Masters, так как услуги используются в мастерах
          dispatch(
            mastersApi.util.invalidateTags([
              { type: "Masters", id: "LIST" },
              { type: "WorktimeMasters", id: "LIST" }
            ])
          )
        } catch {}
      }
    }),
    // put
    updateService: builder.mutation({
      query: ({ service, direction, subCategory }) => ({
        url: `/${SERVICES_PATH}/${service.id}`,
        method: 'PUT',
        body: { ...service }
      }),
      invalidatesTags: [{ type: "Services", id: "LIST" }],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
          // Инвалидируем теги Masters, так как услуги используются в мастерах
          // Это обновит данные мастеров, которые содержат услуги
          dispatch(
            mastersApi.util.invalidateTags([
              { type: "Masters", id: "LIST" },
              { type: "WorktimeMasters", id: "LIST" }
            ])
          )
        } catch {}
      }
    }),
    // delete
    removeService: builder.mutation({
      query: ({id}) => ({
        url: `/${SERVICES_PATH}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Services", id: "LIST" }],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
          // Инвалидируем теги Masters, так как услуги используются в мастерах
          dispatch(
            mastersApi.util.invalidateTags([
              { type: "Masters", id: "LIST" },
              { type: "WorktimeMasters", id: "LIST" }
            ])
          )
        } catch {}
      }
    }),
  }),
})

export const {
  useGetServiceFilterQuery,
  useGetServicesQuery,
  usePostServiceMutation,
  useUpdateServiceMutation,
  useRemoveServiceMutation
} = servicesApi
